import { ScopeChangeRequest } from '@/features/admin/scope-change-requests/ScopeChangeRequest'
import { ModalViewModel } from '@/infra/ModalViewModel'
import { action, observable } from 'mobx'

export class ScopeChangeRequestFinalizedDialogViewModel {
  readonly modal = new ModalViewModel()

  @observable accessor scopeChangeRequest = ScopeChangeRequest.none

  @action.bound
  open(scopeChangeRequest: ScopeChangeRequest) {
    this.scopeChangeRequest = scopeChangeRequest
    this.modal.show()
  }
}
